module.exports = __webpack_public_path__ + "img/V-R-5-unload-connect.f37c589d.png";